import { DAccess } from 'shared/config/dictionaries/userDictionaries';
export var onUserAccess = function (roles) {
    if ((roles === null || roles === void 0 ? void 0 : roles.includes('SuperAdministrator'))
        || (roles === null || roles === void 0 ? void 0 : roles.includes('Administrator'))
        || (roles === null || roles === void 0 ? void 0 : roles.includes('CourseEditor'))) {
        return DAccess.canEditAdmin;
    }
    return DAccess.simpleRights;
};
